import { render, staticRenderFns } from "./welcome-screen.vue?vue&type=template&id=32f82ea8&scoped=true&"
import script from "./welcome-screen.js?vue&type=script&lang=js&"
export * from "./welcome-screen.js?vue&type=script&lang=js&"
import style0 from "./welcome-screen.scss?vue&type=style&index=0&id=32f82ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f82ea8",
  null
  
)

export default component.exports